<template>
  <v-fade-transition>
    <v-app>
      <v-main>
        <router-view />
      </v-main>
    </v-app>
  </v-fade-transition>
</template>

<script>
import { Chat } from "./store/chat";
import { Auth } from "./store/auth";

export default {
  name: "App",
  data() {
    return {
      Chat,
      Auth,
    };
  },
  methods: {
    checkLang() {
      const lang = localStorage.getItem("YPlang");
      lang ? (this.$i18n.locale = lang) : "en";
      lang && lang == "ar"
        ? (this.$vuetify.rtl = true)
        : (this.$vuetify.rtl = false);
    },
  },
  created() {
    this.checkLang();
  },
  async beforeMount() {
    if (this.$i18n.locale == "ar") {
      this.$vuetify.rtl = true;
    } else {
      this.$vuetify.rtl = false;
    }
    if (Auth.token) {
      ("test");
    } else [this.$router.push("/login")];
    await Chat.checkConnectStatus();
  },
  mounted() {
    Chat.getNewMessages();
    Chat.getReadMessages();
  },
};
</script>
<style lang="scss">
@import url("@/assets/scss/styles.scss");
:root {
  --primary: #afb42b;
}
.border {
  border: 2px solid var(--primary);
  border-radius: 5px;
  padding: 3px;
}
</style>
